class CcWorkflowParser {
  E_FAMILY = {
    UI_FRAMEWORK: 0,
    SIMPLE_EDITOR: 1,
    WORKFLOW_ELEMENTS: 3,
  };

  E_FAMILY_CONSUMERS = {
    [this.E_FAMILY.UI_FRAMEWORK]: [this.getUIFrameworkConfig, this.getWorkflowElementsConfig],
    [this.E_FAMILY.SIMPLE_EDITOR]: [this.getSimpleEditorConfig, this.getWorkflowElementsConfig],
    [this.E_FAMILY.WORKFLOW_ELEMENTS]: [this.getWorkflowElementsConfig],
  };

  E_SIMPLE_EDITOR = {
    COMPONENT: "simple-editor",
    TAG_NAME: "au-simple-editor",
    V1: 1,
    V2: 2,
  };

  E_UI_FRAMEWORK_EDITOR = {
    COMPONENT: "ui-framework",
    PARSE_MODE: null,
    TAG_NAME: "au-wizard",
  };

  E_UI_FRAMEWORK_VDP = {
    COMPONENT: "ui-framework-vdp",
    PARSE_MODE: "vdp",
    TAG_NAME: "au-wizard",
  };

  E_FLOW_APP_EDITOR = {
    COMPONENT: "flow-app-editor",
    PARSE_MODE: null,
    TAG_NAME: "au-editor",
  }

  E_FLOW_APP_VDP = {
    COMPONENT: "flow-app-vdp",
    PARSE_MODE: "vdp",
    TAG_NAME: "au-vdp",
  }

  findItem = null;

  constructor(findItem) {
    this.findItem = findItem;
  }

  parse(integrationInfo, options) {
    const configFamily = integrationInfo.configFamily;
    const config = JSON.parse(integrationInfo.config);

    let editorConfig = this.E_FAMILY_CONSUMERS[configFamily].map((consumer) => {
      return consumer.bind(this)(config, options);
    });

    editorConfig = editorConfig.filter((rawConfig) => !!rawConfig);
    editorConfig = editorConfig[0] || {};

    return editorConfig;
  }

  getUIFrameworkConfig(config, options = { parseMode: null }) {
    if (!config) {
      return null;
    }

    if (config['widgets']) {
      return config;
    }

    return null;
  }

  getSimpleEditorConfig(config, options = { parseMode: null }) {
    if (!config) {
      return null;
    }

    if (config['settings']) {
      return config;
    }

    if (config["SE"]) {
      return config["SE"];
    }

    return null;
  }

  getWorkflowElementsConfig(config, options = { parseMode: null }) {
    if (!config) {
      return null;
    }

    if (Array.isArray(config)) {
      
      if (this.findItem === 'UI_FRAMEWORK') {
        let configUIF = null;

        if (options?.parseMode === this.E_UI_FRAMEWORK_VDP.PARSE_MODE) {
          configUIF = config.find((workflowElement) => workflowElement.component === this.E_UI_FRAMEWORK_VDP.COMPONENT);
        }

        if (options?.parseMode === this.E_UI_FRAMEWORK_EDITOR.PARSE_MODE) {
          configUIF = config.find((workflowElement) => workflowElement.component === this.E_UI_FRAMEWORK_EDITOR.COMPONENT);
        }
        
        if (configUIF) {
          if (configUIF?.settings) {
            return configUIF?.settings;
          } else {
            return configUIF;
          }
        }
      }

      if (this.findItem === 'SIMPLE_EDITOR') {
        const configSE = config.find((workflowElement) => {
          return workflowElement.component === this.E_SIMPLE_EDITOR.COMPONENT;
        });
        
        if (configSE) {
          return configSE;
        }
      }

      if (this.findItem === 'FLOW_APP') {
        let configFA = null;

        if (options?.parseMode === this.E_FLOW_APP_VDP.PARSE_MODE) {
          configFA = config.find((workflowElement) => workflowElement.component === this.E_FLOW_APP_VDP.COMPONENT);
        }

        if (options?.parseMode === this.E_FLOW_APP_EDITOR.PARSE_MODE) {
          configFA = config.find((workflowElement) => workflowElement.component === this.E_FLOW_APP_EDITOR.COMPONENT);
        }

        if (configFA) {
          return configFA;
        }
      }
    }

    if (config?.component) {
      return config;
    }

    return null;
  }
}
